import md5 from "md5";
import { createContext, useContext, useEffect, useState } from "react";
import { Get } from "../Utils/Helpers";
import { FetchResponse, ClienteInfo } from "../Utils/Types";

interface ILoginContext {
	loggedIn: boolean;
	setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
	cuil: string;
	setCuil: React.Dispatch<React.SetStateAction<string>>;
	cuilValido: boolean;
	setCuilValido: React.Dispatch<React.SetStateAction<boolean>>;
	pass: string;
	setPass: React.Dispatch<React.SetStateAction<string>>;
	passHashed: string;
	setPassHashed: React.Dispatch<React.SetStateAction<string>>;
	registrado: boolean;
	setRegistrado: React.Dispatch<React.SetStateAction<boolean>>;
	clienteInfo: ClienteInfo;
	setClienteInfo: React.Dispatch<React.SetStateAction<ClienteInfo>>;
	Login: (datos: FetchResponse) => void;
}

export const LoginContext = createContext({} as ILoginContext);
export const useLoginContext = () => useContext(LoginContext);

const Provider = ({ children }) => {
	const [loggedIn, setLoggedIn] = useState(false);
	const [registrado, setRegistrado] = useState(false);
	const [cuil, setCuil] = useState("");
	const [pass, setPass] = useState("");
	const [passHashed, setPassHashed] = useState("");
	const [cuilValido, setCuilValido] = useState(false);
	const [clienteInfo, setClienteInfo] = useState({ codigo: "", razon: "", mail: "" } as ClienteInfo);

	useEffect(() => {
		if (pass.length > 3) {
			(async () => {
				const _hash = await md5(pass);
				setPassHashed(_hash.replaceAll("/", ""));
			})();
		} else if (pass.length === 0) {
			setPassHashed("");
		}
	}, [pass]);

	useEffect(() => {
		if (!loggedIn) {
			setCuil("");
			setPass("");
		}
	}, [loggedIn]);

	useEffect(() => {
		let disposed = false;

		const _valido = cuil.replaceAll("_", "").length === 13;

		setCuilValido(_valido);

		if (_valido) {
			(async () => {
				const result: FetchResponse = await Get(`/Registrado/${cuil}`);

				if (disposed) return;

				setRegistrado(result.resultados);
			})();
		}

		return () => {
			disposed = true;
		};
	}, [cuil]);

	const Login = (datos: FetchResponse): void => {
		const { Codigo, Razon, Mail } = datos.resultados;

		setLoggedIn(true);

		setClienteInfo({
			codigo: Codigo,
			razon: Razon,
			mail: Mail,
		} as ClienteInfo);
	};

	const value = {
		loggedIn,
		setLoggedIn,
		cuil,
		setCuil,
		cuilValido,
		setCuilValido,
		pass,
		setPass,
		passHashed,
		setPassHashed,
		registrado,
		setRegistrado,
		clienteInfo,
		setClienteInfo,
		Login,
	};

	return <LoginContext.Provider value={value}>{children}</LoginContext.Provider>;
};

const obj = {
	Provider,
	Consumer: LoginContext.Consumer,
};

export default obj;
